import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const swatch = (c) => (c?.length === 8 ? `#${c.slice(2)}` : c?.startsWith("theme") ? "#111827" : "#FFFFFF");
const nombreColor = (c) => ({ FFFFFF00: "Amarillo", FF99CC00: "Verde", FFFF99CC: "Rosa", FF00CCFF: "Azul", FF00FFFF: "Celeste", FFFF0000: "Rojo", FF000000: "Negro" }[c] || (c ? (c.startsWith("theme") ? "Negro / del tema" : c) : "Sin color"));

const enviar = (file, extra) => {
  const fd = new FormData();
  fd.append("archivo", file);
  Object.entries(extra).forEach(([k, v]) => fd.append(k, v));
  return api.post("/huecos-tipo/importar", fd);
};

export const ImportarPlanilla = ({ open, centro, profs, onClose, onDone }) => {
  const [file, setFile] = useState(null);
  const [hojas, setHojas] = useState([]);
  const [hoja, setHoja] = useState("");
  const [colores, setColores] = useState([]);
  const [mapa, setMapa] = useState({});
  const [reemplazar, setReemplazar] = useState(true);
  useEffect(() => {
    if (open) { setFile(null); setHojas([]); setHoja(""); setColores([]); setMapa({}); }
  }, [open]);
  const elegirArchivo = async (f) => {
    setFile(f);
    try { setHojas((await enviar(f, {})).data.hojas); } catch (e) { toast.error(errMsg(e)); }
  };
  const elegirHoja = async (h) => {
    setHoja(h); setMapa({});
    try { setColores((await enviar(file, { hoja: h })).data.colores || []); } catch (e) { toast.error(errMsg(e)); }
  };
  const importar = async () => {
    try {
      const { data } = await enviar(file, { hoja, centro, mapa: JSON.stringify(mapa), reemplazar: reemplazar ? "1" : "0" });
      toast.success(`${data.creados} huecos cargados en la semana tipo`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto" data-testid="importar-planilla-dialog">
        <DialogHeader><DialogTitle className="font-[Outfit]">Importar planilla de Excel · {centro === "MADRID" ? "Madrid" : "Alcobendas"}</DialogTitle></DialogHeader>
        <input type="file" accept=".xlsx" onChange={(e) => e.target.files[0] && elegirArchivo(e.target.files[0])} data-testid="importar-archivo" className="text-sm" />
        {hojas.length > 0 && <select className="field-select" value={hoja} onChange={(e) => elegirHoja(e.target.value)} data-testid="importar-hoja">
          <option value="">Elige la pestaña…</option>{hojas.map((h) => <option key={h} value={h}>{h}</option>)}
        </select>}
        {colores.length > 0 && <div className="space-y-2" data-testid="importar-colores">
          <p className="text-xs text-slate-500">Elige de quién es cada color. Los que dejes en «No importar» no se cargan. Los huecos se crean vacíos (sin nombres de pacientes) para que los rellenéis dando citas desde la agenda.</p>
          {colores.map((c) => (
            <div key={c.color || "none"} className="flex items-center gap-2 text-sm" data-testid={`importar-color-${c.color || "none"}`}>
              <span className="h-5 w-5 shrink-0 rounded border border-slate-300" style={{ background: swatch(c.color) }} />
              <span className="w-32">{nombreColor(c.color)} <span className="text-xs text-slate-400">({c.n})</span></span>
              <select className="field-select flex-1" value={mapa[c.color] || ""} onChange={(e) => setMapa({ ...mapa, [c.color]: e.target.value })}>
                <option value="">No importar</option>{profs.map((p) => <option key={p.id} value={p.id}>{p.nombre}</option>)}
              </select>
              <span className="hidden md:block w-40 truncate text-[11px] text-slate-400" title={c.ejemplos.join(", ")}>{c.ejemplos.join(", ")}</span>
            </div>
          ))}
          <label className="flex items-center gap-2 text-xs text-slate-600"><input type="checkbox" checked={reemplazar} onChange={(e) => setReemplazar(e.target.checked)} data-testid="importar-reemplazar" />Sustituir los huecos que ya tengan esas profesionales en este centro</label>
        </div>}
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={importar} disabled={!Object.values(mapa).some(Boolean)} data-testid="importar-submit" className="bg-[#1E3A8A] hover:bg-[#1E40AF]">Importar</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
